import { loadMetricsModule } from "./reportWebLoader";

const reportWebVitals = (onPerfEntry) => {
  if (typeof onPerfEntry === "function") {
    loadMetricsModule().then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
